import { IPFS_GATEWAY } from '@/constants/constants';

export const getAvatarUrl = (cid: string) => {
  return `${IPFS_GATEWAY}${cid}?img-format=webp`;
}
